export { applyOutputMapping } from './applyOutputMapping'
